var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colorfilter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3333 16C14.3333 17.77 13.5633 19.37 12.3333 20.46C11.2733 21.42 9.87325 22 8.33325 22C5.02325 22 2.33325 19.31 2.33325 16C2.33325 13.24 4.21325 10.9 6.75325 10.21C7.44325 11.95 8.92325 13.29 10.7533 13.79C11.2533 13.93 11.7833 14 12.3333 14C12.8833 14 13.4133 13.93 13.9133 13.79C14.1833 14.47 14.3333 15.22 14.3333 16Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3333 8C18.3333 8.78 18.1833 9.53 17.9133 10.21C17.2233 11.95 15.7433 13.29 13.9133 13.79C13.4133 13.93 12.8833 14 12.3333 14C11.7833 14 11.2533 13.93 10.7533 13.79C8.92325 13.29 7.44325 11.95 6.75325 10.21C6.48325 9.53 6.33325 8.78 6.33325 8C6.33325 4.69 9.02325 2 12.3333 2C15.6433 2 18.3333 4.69 18.3333 8Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.3333 16C22.3333 19.31 19.6433 22 16.3333 22C14.7933 22 13.3933 21.42 12.3333 20.46C13.5633 19.37 14.3333 17.77 14.3333 16C14.3333 15.22 14.1833 14.47 13.9133 13.79C15.7433 13.29 17.2233 11.95 17.9133 10.21C20.4533 10.9 22.3333 13.24 22.3333 16Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.033b6de523b0c24fc3e963967343a147.svg";
export { ForwardRef as ReactComponent };